module.exports = __webpack_public_path__ + "static/media/underline.22310fe7.svg";